import { useMemo } from 'react'
import { cn } from '@/utils/styles/cn'

interface IRestaurantTagsProps {
    tags: string[] | Array<{ name: string }> | undefined | null
    className?: string
    maxTags?: number
}

export const RestaurantTags = ({ tags: rawTags, className, maxTags }: IRestaurantTagsProps) => {
    const tags = useMemo(() => {
        if (!rawTags?.length) return null

        if (typeof rawTags[0] === 'string') return rawTags as string[]

        return (rawTags as Array<{ name: string }>).map((tag) => tag.name)
    }, [rawTags])

    const computedTags = useMemo(() => {
        if (!maxTags) return tags

        return tags?.slice(0, maxTags)
    }, [tags, maxTags])

    if (!computedTags || !computedTags.length) return null

    return (
        <div
            className={cn(
                `flex flex-row items-center md:text-[14px] text-[14px] w-full max-w-fit whitespace-nowrap
                overflow-hidden text-ellipsis`,
                className
            )}
        >
            <p className="w-full max-w-fit whitespace-nowrap overflow-hidden text-ellipsis">
                {computedTags.join(', ')}
            </p>
        </div>
    )
}
